import * as React from 'react';
import { VmsItem } from './VmsItem';
import { Vms } from './VmsMenu';

export interface IVmsListProps {
    vms: Vms[];
    currentRegion: string;
    isfavorite: boolean;
}

interface IVmsListState {
    vms: Vms[];
}

export class VmsList extends React.Component<IVmsListProps, IVmsListState> {
    constructor(props: IVmsListProps) {
        super(props);

        if (!this.props.isfavorite) {
            this.state = { vms: this.props.vms };
        } else {
            this.state = { vms: [] };
        }
    }

    public componentDidMount(): void {
        if (!this.props.isfavorite) {
            return;
        }

        const favorited = this.setFavorite(this.props.vms);
        const my = favorited.filter((c) => c.isFavorite);

        this.setState({ vms: my });
    }

    public renderItem(item: Vms, index: number): JSX.Element {
        return (
            <div className="col-12 col-sm-6 col-lg-4 vms-column" key={index}>
                <VmsItem vms={item} currentRegion={this.props.currentRegion} isfavorite={this.props.isfavorite} renderAsLink={true} />
            </div>
        );
    }

    public render(): JSX.Element {
        return <div className="row">{this.state.vms.map(this.renderItem.bind(this))}</div>;
    }

    private setFavorite(items: Vms[]): Vms[] {
        const favorites = this.getFavoriteSigns();

        const result: Vms[] = items.map((c) => {
            c.isFavorite = favorites.indexOf(Number(c.id)) > -1;

            return c;
        });

        return result;
    }

    private getFavoriteSigns(): number[] {
        const key = 'MySignPages' + this.props.currentRegion.toUpperCase();
        const ids = localStorage[key] ? (JSON.parse(localStorage[key]) as string[]) : [];

        return ids.reduce((total, current) => {
            const id = Number(current);

            if (!isNaN(id) && id !== 0) {
                total.push(id);
            }
            return total;
        }, []);
    }
}
